var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["CASH"] = 1] = "CASH";
    PaymentMethod[PaymentMethod["CHEQUE"] = 2] = "CHEQUE";
    PaymentMethod[PaymentMethod["CREDIT_CARD"] = 3] = "CREDIT_CARD";
    PaymentMethod[PaymentMethod["PAYME"] = 4] = "PAYME";
    PaymentMethod[PaymentMethod["ATM_TRANSFER"] = 5] = "ATM_TRANSFER";
    PaymentMethod[PaymentMethod["OTHER"] = 9] = "OTHER";
})(PaymentMethod || (PaymentMethod = {}));
export default PaymentMethod;
